import { updateAttachment } from 'common/api/attachments';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_FAILURE, SAVE_SUCCESS } from '../actionTypes';
import { attachmentsActions } from '../reducer';

import filterAttachments from './filterAttachments';

export default (filterData, values) => (dispatch) => {
    if (!values.id) return;

    const newValues = {
        title: values.title,
    };

    dispatch(attachmentsActions[SAVE]());

    updateAttachment(newValues, values.id)
        .then(() => {
            dispatch(attachmentsActions[SAVE_SUCCESS]());
            dispatch(filterAttachments(filterData));
            showToast();
        })
        .catch((error) =>
            dispatch(
                attachmentsActions[SAVE_FAILURE](error?.response?.data?.errors),
            ),
        );
};
